// import { CTAButtonTypes } from "../components/ctaButton";
export const CTAButtonTransformer = (allAvailableLocations: any, CTAConfigs: any) => {
    const generateCTALinks = (routeName: any) => {
        if (allAvailableLocations.length > 1 && (routeName === "pay_rent" || routeName === "view_rates" || routeName === "contact_us")) {
            return '/select-location-page/'
        }
        if (allAvailableLocations.length) {
            const { locationCity, locationState } = allAvailableLocations[0];
            const cleanStateName = locationState.replace(/\s+/g, '-').toLowerCase();
            const cleanCityName = locationCity.replace(/\s+/g, '-').toLowerCase();
            const cleanRouteName = routeName.replace(/_/g, '-').toLowerCase();
            if (routeName === 'reserve_unit') {
                return `/${cleanStateName}/${cleanCityName}/view-rates/reserve/`
            }
            return `/${cleanStateName}/${cleanCityName}/${cleanRouteName}/`
        }
    }
    return CTAConfigs.map((indivCTAConfig: any) => {
        const link = generateCTALinks(indivCTAConfig.url)
        return {
            ...indivCTAConfig,
            link
        }
    })
}